import React, { Component } from "react";
import { Modal, message, Spin } from "antd";
import axios from "axios";
import {
  Form,
  FormItem,
  InputItem,
  ButtonItem,
  TextAreaItem,
  SelectItem,
} from "../../../../Components/Items";
import {
  FUENTES_OPCIONES,
  fuenteOpcionesDesdeKey,
  keyDesdeFuenteOpciones,
} from "../fuentesOpciones";

const TIPOS_PERMISO = [
  { value: "boolean", label: "Booleano (solo activar/desactivar)" },
  { value: "monto", label: "Monto (límite numérico)" },
  { value: "seleccion", label: "Selección (elegir de una lista)" },
];

class ModalPermisos extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    tipoSeleccionado: "boolean",
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      if (this.props.itemEditandoId) {
        this.consultarItem(this.props.itemEditandoId, this.props.tipoModal);
      } else {
        if (this.formRef.current) this.formRef.current.resetFields();
        this.setState({ tipoSeleccionado: "boolean" });
      }
    }
  }

  consultarItem = async (id, tipo) => {
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "permisos/obtenerDetalleItem",
        { itemId: id, tipo: tipo },
        { headers: this.props.headersToken },
      );

      if (res.data.success && this.formRef.current) {
        const item = res.data.item || {};
        const tipoPermiso = item.tipo || "boolean";

        const fuente = keyDesdeFuenteOpciones(item.fuenteOpciones);
        this.formRef.current.setFieldsValue({
          ...item,
          tipo: tipoPermiso,
          fuente,
        });
        this.setState({ tipoSeleccionado: tipoPermiso });
      } else {
        message.error("No se pudo cargar la información del registro");
        this.props.onCancel();
      }
    } catch (error) {
      console.error(error);
      message.error("Error de conexión al cargar los datos");
    } finally {
      this.setState({ loading: false });
    }
  };

  onChangeTipo = (value) => {
    this.setState({ tipoSeleccionado: value });
    if (value !== "seleccion" && this.formRef.current) {
      this.formRef.current.setFieldsValue({ fuente: undefined });
    }
  };

  guardarItem = async (values) => {
    const { tipoModal, itemEditandoId, grupoActivoId, subGrupoDestinoId } =
      this.props;
    this.setState({ loading: true });

    let payload = { ...values };
    let endpoint = "";

    // Para permisos tipo "seleccion" el form maneja una "key" de fuente; el
    // backend espera el objeto fuenteOpciones. Traducimos antes de enviar.
    if (tipoModal === "permiso") {
      if (values.tipo === "seleccion") {
        payload.fuenteOpciones = fuenteOpcionesDesdeKey(values.fuente);
      }
      delete payload.fuente;
    }

    if (tipoModal === "grupo") {
      // Grupo : Editar si tiene id, crear si no
      endpoint = itemEditandoId
        ? "permisos/editarGrupo"
        : "permisos/crearGrupo";
      if (itemEditandoId) payload.grupoId = itemEditandoId;
    } else if (tipoModal === "subgrupo") {
      // SubGrupo : Editar si tiene id, crear si no
      endpoint = itemEditandoId
        ? "permisos/editarSubGrupo"
        : "permisos/crearSubGrupo";
      payload.grupoId = grupoActivoId;
      if (itemEditandoId) payload.subGrupoId = itemEditandoId;
    } else if (tipoModal === "permiso") {
      // Permiso : Editar si tiene id, crear si no
      endpoint = itemEditandoId
        ? "permisos/editarPermiso"
        : "permisos/crearPermiso";
      payload.subGrupoId = subGrupoDestinoId;
      if (itemEditandoId) payload.permisoId = itemEditandoId;
    }

    try {
      const res = await axios.post(endpoint, payload, {
        headers: this.props.headersToken,
      });

      if (res.data.success) {
        message.success(`${tipoModal.toUpperCase()} guardado correctamente`);
        if (this.formRef.current) this.formRef.current.resetFields();
        this.props.onSuccess();
      } else {
        message.error(res.data.message || "Error al guardar");
      }
    } catch (error) {
      console.error(error);
      message.error("Ocurrió un error al guardar, verifica tu conexión.");
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { visible, onCancel, tipoModal, itemEditandoId } = this.props;
    const titulo = `${itemEditandoId ? "Editar" : "Nuevo"} ${tipoModal ? tipoModal.toUpperCase() : ""}`;
    const esPermiso = tipoModal === "permiso";

    return (
      <Modal
        title={titulo}
        visible={visible}
        onCancel={() => {
          if (this.formRef.current) this.formRef.current.resetFields();
          this.setState({ tipoSeleccionado: "boolean" });
          onCancel();
        }}
        footer={null}
        destroyOnClose
      >
        <Spin spinning={this.state.loading}>
          <Form
            ref={this.formRef}
            layout="vertical"
            onFinish={this.guardarItem}
            initialValues={esPermiso ? { tipo: "boolean" } : undefined}
          >
            <FormItem
              label="Nombre"
              name="nombre"
              rules={[{ required: true, message: "Ingresa el nombre" }]}
            >
              <InputItem placeholder="Nombre" />
            </FormItem>

            <FormItem label="Descripción" name="descripcion">
              <TextAreaItem placeholder="Descripción..." />
            </FormItem>

            <FormItem label="Número de Orden" name="numero">
              <InputItem type="number" placeholder="Ej. 1" />
            </FormItem>

            {esPermiso ? (
              <>
                <FormItem
                  label="Tipo de permiso"
                  name="tipo"
                  rules={[{ required: true, message: "Selecciona el tipo de permiso" }]}
                >
                  <SelectItem
                    placeholder="Selecciona el tipo"
                    options={TIPOS_PERMISO}
                    onChange={this.onChangeTipo}
                  />
                </FormItem>

                {this.state.tipoSeleccionado === "seleccion" ? (
                  <FormItem
                    label="Fuente de opciones"
                    name="fuente"
                    rules={[{ required: true, message: "Selecciona la fuente de opciones" }]}
                    extra="De qué catálogo saldrán las opciones que el administrador podrá elegir al asignar este permiso"
                  >
                    <SelectItem
                      placeholder="Selecciona la fuente"
                      options={FUENTES_OPCIONES}
                    />
                  </FormItem>
                ) : null}
              </>
            ) : null}

            <ButtonItem
              type="primary"
              htmlType="submit"
              style={{ width: "100%" }}
            >
              Guardar
            </ButtonItem>
          </Form>
        </Spin>
      </Modal>
    );
  }
}

export default ModalPermisos;
